export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/202853ac-baef-4d95-83b8-eae3c696065f/images/8f090b986943aac59702ffa145ddef6e2cf53144506e72216c20b139ec082330.jpeg",
  aiOrb: "https://static.prod-images.emergentagent.com/jobs/202853ac-baef-4d95-83b8-eae3c696065f/images/27df2ef5e6bf7a55ad9679cee21beead4458f1286b5edcf60d8aadc8871ae248.jpeg",
  examScene: "https://static.prod-images.emergentagent.com/jobs/202853ac-baef-4d95-83b8-eae3c696065f/images/05dde171d981e2165e9915e821cf461cd1102f0720eadad55059ff5d30433046.jpeg",
  python: "https://static.prod-images.emergentagent.com/jobs/202853ac-baef-4d95-83b8-eae3c696065f/images/02908d9a898d348d20606c10f890d94cb8c1f8ad38a8cb3f340a8deba5bfbe2d.jpeg",
  aws: "https://static.prod-images.emergentagent.com/jobs/202853ac-baef-4d95-83b8-eae3c696065f/images/16e6b5464e7f5027aee078dc4a862e5d10cf8894fd73992d309d372b785a825e.jpeg",
  azure: "https://static.prod-images.emergentagent.com/jobs/202853ac-baef-4d95-83b8-eae3c696065f/images/b989b395133208d671328a9188d4db56a99fd313016a1399c481f0dfca6f5c03.jpeg",
  gcp: "https://static.prod-images.emergentagent.com/jobs/202853ac-baef-4d95-83b8-eae3c696065f/images/8dfbfdb243b230e4499c60aa56d2bb436086ac7f0bd58bafa46491083c7949af.jpeg",
};

export function courseImage(c) {
  const p = c.provider || "";
  if (p.includes("Python")) return IMAGES.python;
  if (p.includes("Amazon")) return IMAGES.aws;
  if (p.includes("Azure")) return IMAGES.azure;
  if (p.includes("Google")) return IMAGES.gcp;
  return IMAGES.aws;
}
